// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___v4odL {
    display: flex;
    flex-direction: row;
    background-color: #f3f3f3;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    padding: 8px;
}

.style__input___vEf3e {
    border: none;
    outline: none;
    background-color: #f3f3f3;
    padding-left: 8px;
    padding-right: 8px;
    width: 40vw;
    font-size: 17px;
}

`, "",{"version":3,"sources":["webpack://./src/components/SearchBar/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    background-color: #f3f3f3;\n    border-radius: 16px;\n    justify-content: center;\n    align-items: center;\n    padding: 8px;\n}\n\n.input {\n    border: none;\n    outline: none;\n    background-color: #f3f3f3;\n    padding-left: 8px;\n    padding-right: 8px;\n    width: 40vw;\n    font-size: 17px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___v4odL`,
	"input": `style__input___vEf3e`
};
export default ___CSS_LOADER_EXPORT___;
